<template>
    <Loader :isActive="hasReady"></Loader>
    <div
        class="config-form-content weeducAdminIntegrations weeduc-admin-config"
    >
        <div class="content-wrapper primary">
            <div class="wrapper-inner">
                <div class="content-form">
                    <div class="main-container">
                        <div class="container-form">
                            <div class="second-container">
                                <div
                                    class="col-form-inner col-12 col-md-12 col-lg-12 select"
                                >
                                    <div class="form-group-container">
                                        <label class="label-form"
                                            >Facebook Pixel:
                                        </label>
                                        <div class="form-input">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="GTM-28CJ0"
                                                v-model="facebook"
                                            />
                                            <small class="small"
                                                >Insira seu código para rastrear
                                                e analisar o comportamento dos
                                                visitantes.</small
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="col-form-inner col-12 col-md-12 col-lg-12 select"
                                >
                                    <div class="form-group-container">
                                        <label class="label-form"
                                            >Google Ads Pixel:
                                        </label>
                                        <div class="form-input">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="GTM-28CJ0"
                                                v-model="gads"
                                            />
                                            <small class="small"
                                                >Insira seu código para
                                                monitorar conversões de
                                                anúncios.</small
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="col-form-inner col-12 col-md-12 col-lg-12 select"
                                >
                                    <div class="form-group-container">
                                        <label class="label-form"
                                            >Google Analytics Code:
                                        </label>
                                        <div class="form-input">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="GTM-28CJ0"
                                                v-model="ganalytic"
                                            />
                                            <small class="small"
                                                >Insira seu código para
                                                acompanhar acessos e interações
                                                no site.</small
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="col-form-inner col-12 col-md-12 col-lg-12 select"
                                >
                                    <div class="form-group-container">
                                        <label class="label-form"
                                            >Tag Manager Code:
                                        </label>
                                        <div class="form-input">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="GTM-28CJ0"
                                                v-model="tagManager"
                                            />
                                            <small class="small"
                                                >Insira seu código para
                                                gerenciar e ativar tags no
                                                site.</small
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="container-form">
                            <div
                                class="col-form-inner col-12 col-md-12 col-lg-12 select"
                            >
                                <div class="form-group-container">
                                    <label class="label-form"
                                        >RDRefresh Code:
                                    </label>
                                    <div class="form-input">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="GTM-28CJ0"
                                            v-model="rdrefreshToken"
                                        />
                                        <small class="small"
                                            >Informe o código de RDRefresh para
                                            integrar suas estratégias de
                                            marketing digital e automação de
                                            marketing.</small
                                        >
                                    </div>
                                </div>
                            </div>

                            <div
                                class="col-form-inner col-12 col-md-12 col-lg-12 select"
                            >
                                <div class="form-group-container">
                                    <label class="label-form"
                                        >RDStation Code:
                                    </label>
                                    <div class="form-input">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="GTM-28CJ0"
                                            v-model="rdcode"
                                        />
                                        <small class="small"
                                            >Insira seu código RDStation, para
                                            atualiza a integração e
                                            automatizando das suas estratégias
                                            de marketing.</small
                                        >
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-form-inner col-12 col-md-12 col-lg-12 select"
                            >
                                <div class="form-group-container">
                                    <label class="label-form"
                                        >RDStation Secret Client:
                                    </label>
                                    <div class="form-input">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="GTM-28CJ0"
                                            v-model="rdSecret"
                                        />
                                        <small class="small"
                                            >Insira o código secreto de
                                            autenticação do RDStation.</small
                                        >
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-form-inner col-12 col-md-12 col-lg-12 select"
                            >
                                <div class="form-group-container">
                                    <label class="label-form"
                                        >RDStation Client ID:
                                    </label>
                                    <div class="form-input">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="GTM-28CJ0"
                                            v-model="rdClient"
                                        />
                                        <small class="small"
                                            >Insira o ID do cliente para
                                            conectar ao RDStation.</small
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="buttons-container">
            <div class="button" v-show="hasSite">
                <button
                    type="button"
                    @click="save()"
                    class="btn btn-block btn-content"
                >
                    Salvar Edição e Publicar
                </button>
                <button
                    type="button"
                    @click="clearCache()"
                    class="btn btn-block btn-content"
                >
                    Limpar Cache
                </button>
            </div>
            <div class="button" v-show="!hasSite">
                <button
                    type="button"
                    @click="save()"
                    class="btn btn-block btn-content"
                >
                    Criar e Publicar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/utils/site';
    import apiSiteIntegration from '@/utils/Site/integrations';
    import apiAWS from '@/utils/storage/aws';
    import { mapState, mapActions } from 'vuex';
    import Loader from '@/components/Loader/loader.vue';
    import { toast } from 'vue3-toastify';


    export default {
        data() {
            return {
                hasSite: false,
                tagManager: '',
                ganalytic: '',
                gads: '',
                rdSecret: '',
                rdClient: '',
                rdcode: '',
                rdrefreshToken: '',
                id: null,
                hasSaved: false,
                hasReady: false,
                windowWidth: window.innerWidth,
            };
        },
        computed: {
            ...mapState(['token']),
            responsiveIntegrationsClassOne() {
                return this.windowWidth <= 500
                    ? 'col-form-outer col-12 col-md-6 col-lg-6 col-1'
                    : 'col-form-outer col-6 col-md-6 col-lg-6 col-1';
            },
        },
        methods: {
            async getConfigSite() {
                try {
                    const response =
                        await apiSiteIntegration.getIntegrationData(this.token);

                    this.hasSite = true;
                    this.tagManager = response.tagManagerCode;
                    this.ganalytic = response.googleAnalyticsCode;
                    this.facebook = response.facebookPixelCode;
                    this.gads = response.googleAdsCode;
                    this.rdSecret = response.rdsecretClient;
                    this.rdClient = response.rdclienteId;
                    this.rdcode = response.rdcode;
                    this.rdrefreshToken = response.rdrefreshToken;
                    this.hasReady = true;
                } catch (error) {
                    toast.error('Erro ao carregar as configurações do Site');
                    console.error(
                        'Erro ao carregar as configurações do Site',
                        error
                    );
                }
            },
            async editSite() {
                this.hasReady = false;
                const obj = {
                    tagManagerCode: this.tagManager,
                    googleAnalyticsCode: this.ganalytic,
                    facebookPixelCode: this.facebook,
                    googleAdsCode: this.gads,
                    rdsecretClient: this.rdSecret,
                    rdclienteId: this.rdClient,
                    rdcode: this.rdcode,
                    rdrefreshToken: this.rdrefreshToken,
                };
                try {
                    const response =
                        await apiSiteIntegration.putIntegrationData(
                            this.token,
                            obj
                        );
                    this.getConfigSite();
                    toast.success('Configurações do site editadas com sucesso!');
                } catch (error) {
                    toast.error('Erro ao editar as configurações do site.');
                    console.error('Erro ao Editar Site', error);
                }
            },
            async clearCache() {
                try {
                    this.hasReady = true;
                    await api.clearCache(this.token);
                    toast.success('Cache limpo com sucesso!');
                } catch (error) {
                    toast.error('Erro ao limpar cache.');
                } finally {
                    this.hasReady = false;
                }
            },
            save() {
                this.editSite();
                this.hasSaved = true;
            },
        },
        props: {
            saved: Boolean,
        },
        created() {
            this.getConfigSite();
        },
        components: {
            Loader,
        },
    };
</script>

<style scoped>
    @import '@/css/weeduc/admin/integrations.css';
</style>
